import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Pagination as MUIPagination } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPagination = styled(MUIPagination) `
  background-color: transparent;
  box-shadow: none;
  padding: .5rem 0;

  li {
    margin: 0 -.033rem;

    :first-of-type, :last-of-type {
      margin: 0;
    }

    button {
      border-radius: 0;
      border-color: #dfe3e6;
      color: #006c9c;
      font-family: 'Whitney Book';
      font-size: 16px;
      margin: 0;
      height: 44px;
      width: 44px;

      &.Mui-selected {
        background-color: #3498db;
        color: white;

        :hover, :focus {
          background-color: #3498db;
        }
      }

      :hover, :focus {
        background-color: #f8f8f8;
      }
    }
  }

  ul {
    float: right;
  }
`;

export class Pagination extends React.Component {
  static defaultProps = {
    currentPage: 0,
    totalCount: 0,
    perPage: 25,
    handlePageChange: (e, page) => { console.log(page) },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateScreenSize);
  }

  updateScreenSize = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { currentPage, perPage, count, handlePageChange } = this.props;
    return (
      <StyledPagination
        count={count}
        variant="outlined"
        shape="rounded"
        onChange={handlePageChange}
        siblingCount={screen.width > 800 ? 1 : 0}
      />
    );
  }
}
